import * as React from "react";
import { css } from "emotion";
import { Grid } from "../grid/grid";
const formClass = css({
    height: "100%",
});
const formMainContent = css({
    overflow: "auto",
});
export const HorizontalForm = (props) => {
    const { children, header, actionBar, actionBarHeight, padding } = props;
    return (React.createElement("form", { onSubmit: (e) => e.preventDefault(), className: formClass },
        React.createElement(Grid, { columns: 1, rowSpec: `min-content 1fr ${actionBarHeight || 64}px`, height: [100, "%"], padding: padding },
            React.createElement("div", null, header),
            React.createElement("div", { className: formMainContent }, children),
            React.createElement("div", null, actionBar))));
};
export default HorizontalForm;
//# sourceMappingURL=horizontalform.js.map